var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',[(!_vm.caseId)?_c('span'):_c('a',{attrs:{"href":'https://aels.ade.arkansas.gov/AELS/View/PLView.aspx?CID=' + _vm.caseId,"target":"_blank"}},[_vm._v(_vm._s(_vm.caseId))])])])}
var staticRenderFns = []

export { render, staticRenderFns }